import { getOverlayContainer } from './overlay.js';

export interface VxHighlightOptions {
    highlight?: boolean;
    clearOverlay?: boolean;
    includeAll?: boolean;
    filterRefs?: string[];
    useColors?: boolean;
}

export function highlightEl(el: Element, ref: string, color?: string) {
    if (!(el instanceof Element)) {
        return;
    }
    if (el instanceof HTMLOptGroupElement) {
        return;
    }
    if (el instanceof HTMLOptionElement) {
        return;
    }
    const container = getOverlayContainer();
    const rect = el.getBoundingClientRect();
    const overlay = document.createElement('div');
    container.appendChild(overlay);
    overlay.style.position = 'absolute';
    overlay.style.top = `${rect.top}px`;
    overlay.style.left = `${rect.left}px`;
    overlay.style.width = `${rect.width}px`;
    overlay.style.height = `${rect.height}px`;
    overlay.style.border = `2px solid ${color}`;
    const label = document.createElement('div');
    overlay.appendChild(label);
    label.style.position = 'absolute';
    label.style.bottom = `100%`;
    label.style.left = `0`;
    label.style.backgroundColor = color ?? getRandomColor(ref);
    label.style.color = 'white';
    label.style.fontSize = '10px';
    label.style.fontFamily = 'monospace';
    label.style.fontWeight = 'normal';
    label.style.fontStyle = 'normal';
    label.style.opacity = '0.8';
    label.style.padding = '0 2px';
    label.style.transform = 'translateY(50%)';
    label.textContent = String(ref);
}

function getRandomColor(ref: string) {
    const index = ref.charCodeAt(0);
    const hue = (index * 120 * .382) % 360;
    return `hsl(${hue}, 85%, 50%)`;
}
